export const SUCCESS_ALERT = "SUCCESS_ALERT";
export const WARNING_ALERT = "WARNING_ALERT";
export const ERROR_ALERT = "ERROR_ALERT";
export const RESET_ALERT = "RESET_ALERT";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
